export default __webpack_public_path__ + "static/media/bones.7b1dcaa6.png";